/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GovernanceAnswer } from './GovernanceAnswer';
import { GovernanceAnswerFromJSON, GovernanceAnswerFromJSONTyped, GovernanceAnswerToJSON } from './GovernanceAnswer';

/**
 *
 * @export
 * @interface PaginatedGovernanceAnswerList
 */
export interface PaginatedGovernanceAnswerList {
  /**
   *
   * @type {number}
   * @memberof PaginatedGovernanceAnswerList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedGovernanceAnswerList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedGovernanceAnswerList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<GovernanceAnswer>}
   * @memberof PaginatedGovernanceAnswerList
   */
  results: Array<GovernanceAnswer>;
}

/**
 * Check if a given object implements the PaginatedGovernanceAnswerList interface.
 */
export function instanceOfPaginatedGovernanceAnswerList(value: object): value is PaginatedGovernanceAnswerList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedGovernanceAnswerListFromJSON(json: any): PaginatedGovernanceAnswerList {
  return PaginatedGovernanceAnswerListFromJSONTyped(json, false);
}

export function PaginatedGovernanceAnswerListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedGovernanceAnswerList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(GovernanceAnswerFromJSON),
  };
}

export function PaginatedGovernanceAnswerListToJSON(value?: PaginatedGovernanceAnswerList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(GovernanceAnswerToJSON),
  };
}
